import types from '../mutation-types';
import ConversationApi from '../../api/inbox/conversation';

const state = {
  mineCount: 0,
  unAssignedCount: 0,
  allCount: 0,
  // 系统文件夹统计
  currentAgentCount: 0,
  agentHistoryCount: 0,
  botCount: 0,
  // 所有会话总数（不分状态）
  totalCount: 0,
  // "所有会话"菜单 - status=open时的所有会话数
  openAllCount: 0,
  updatedOn: null,
};

export const getters = {
  getStats: $state => $state,
};

export const actions = {
  get: async ({ commit, state: $state }, params) => {
    const currentTime = new Date();
    const lastUpdatedTime = new Date($state.updatedOn);

    // Skip large accounts from making too many requests
    if (currentTime - lastUpdatedTime < 10000 && $state.allCount > 1000) {
      // eslint-disable-next-line no-console
      console.warn('Skipping conversation meta fetch');
      return;
    }

    try {
      const response = await ConversationApi.meta(params);
      const {
        data: { meta },
      } = response;
      commit(types.SET_CONV_TAB_META, meta);
    } catch (error) {
      // Ignore error
    }
  },
  set({ commit }, meta) {
    commit(types.SET_CONV_TAB_META, meta);
  },
};

export const mutations = {
  [types.SET_CONV_TAB_META](
    $state,
    {
      mine_count: mineCount,
      unassigned_count: unAssignedCount,
      all_count: allCount,
      current_agent_count: currentAgentCount,
      agent_history_count: agentHistoryCount,
      bot_count: botCount,
      total_count: totalCount,
      open_all_count: openAllCount,
    } = {}
  ) {
    $state.mineCount = mineCount;
    $state.allCount = allCount;
    $state.unAssignedCount = unAssignedCount;
    // 系统文件夹统计 - 只有当 API 返回有效值时才更新,避免被过滤后的请求覆盖
    if (currentAgentCount !== undefined && currentAgentCount !== null) {
      $state.currentAgentCount = currentAgentCount;
    }
    if (agentHistoryCount !== undefined && agentHistoryCount !== null) {
      $state.agentHistoryCount = agentHistoryCount;
    }
    if (botCount !== undefined && botCount !== null) {
      $state.botCount = botCount;
    }
    // 所有会话总数 - 只有当 API 返回有效值时才更新
    if (totalCount !== undefined && totalCount !== null) {
      $state.totalCount = totalCount;
    }
    // "所有会话"菜单 - 只有当 API 返回有效值时才更新
    if (openAllCount !== undefined && openAllCount !== null) {
      $state.openAllCount = openAllCount;
    }
    $state.updatedOn = new Date();
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
